import React, { useEffect, useState } from "react";
import { useSubheader } from "../../_metronic/layout";
import { /* useSelector,  */ connect } from "react-redux";
import { injectIntl } from "react-intl";
import * as auth from "../modules/Auth/_redux/authRedux";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../_metronic/_helpers";
import { Accordion, Card, Button, Form } from "react-bootstrap";
import Axios from "axios";
import { Modal } from "react-bootstrap/";

const FAQS_URL = process.env[`REACT_APP_${process.env.REACT_APP_ENV.toUpperCase()}_URL`] + "/v1/faqs/";
function getFaqs(setFaqs) {
  // GET request using fetch inside useEffect React hook
  Axios.get(FAQS_URL)
    .then((response) => response.data)
    .then((data) => {
      setFaqs(data.payload || {});
      console.log(data);
    })
    .catch(() => { });
}
function deleteFaq(uid, callback) {
  // GET request using fetch inside useEffect React hook
  Axios.delete(FAQS_URL + uid)
    .then((response) => response.data)
    .then(() => {
      callback();
    })
    .catch(() => { });
}

function Profile() {
  const suhbeader = useSubheader();
  suhbeader.setTitle("Support Center");
  const [queryng, setQuery] = useState(true)

  /*  const { user } = useSelector((state) => state.auth); */
  const [key, setKey] = useState("0");
  const [faqs, setFaqs] = useState([]);
  const [initvalues, setInitvalues] = useState(null);
  const fetchFaqs = () => getFaqs((args) => {
    setFaqs(args);
    return setQuery(false)
  });
  useEffect(fetchFaqs, []);

  /*  const current = user.uid ? user : user.payload; */

  const [modalShow, setModalShow] = React.useState(false);
  return (
    <>
      <div
        className="content d-flex flex-column flex-column-fluid"
        id="kt_content"
      >
        <div className="d-flex flex-column-fluid">
          <div className="container">
            <div className="text-center pt-1">
              <h1 className="font-weight-bolder text-dark mb-6">
                Frequently Asked Questions
              </h1>
              <div className="h4 text-dark-50">
                Deep Dive into our Knowledgebase
              </div>
              <div className="row">
                <div className="offset-md-9 col-md-3">
                  <span className="svg-icon svg-icon-full">
                    <SVG
                      src={toAbsoluteUrl(
                        "/media/svg/illustrations/data-points.svg"
                      )}
                    />
                  </span>
                </div>
              </div>
            </div>
            <div className="card card-custom p-4 mb-10">
              <div className="card-body d-flex align-items-center justify-content-between">
                <div>
                  <h3 className="text-dark">Did not find an FAQ?</h3>
                </div>

                <>
                  <button
                    variant="primary"
                    onClick={() => {
                      setInitvalues(null);
                      setModalShow(true);
                    }}
                    className="btn font-weight-bolder text-uppercase font-size-lg btn-primary px-6"
                  >
                    Create a FAQ
                  </button>
                  <ContainerButtonFaqs
                    addfaq={(faq) => {
                      faqs.push(faq);
                      setFaqs(faqs);
                    }}
                    fetchFaqs={fetchFaqs}
                    initvalues={initvalues}
                    show={modalShow}
                    onHide={() => setModalShow(false)}
                  />
                </>
              </div>
            </div>
            <Accordion
              defaultActiveKey={key}
              className="accordion accordion-solid accordion-panel accordion-svg-toggle mb-10"
            >
              {faqs.length ? (
                faqs.map((faq) => {
                  return (
                    <Card
                      className="card-title font-size-h4 text-dark collapsed p-6"
                      key={faq.uid}
                    >
                      <Accordion.Toggle
                        as={Card.Header}
                        eventKey={String(faq.uid)}
                        onClick={() => setKey(String(faq.uid))}
                        className="card-title font-size-h4 text-dark collapsed"
                      >
                        <div className="row p-4 align-items-center justify-content-between">
                          <div className="card-label">
                            <b>{faq.question}</b>
                          </div>
                          <span className="svg-icon svg-icon-primary">
                            <div
                              title="See Faq"
                              className="btn btn-icon btn-light btn-hover-primary btn-sm"
                            >
                              <span className="svg-icon svg-icon-md svg-icon-primary">
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/icons/General/Visible.svg"
                                  )}
                                />
                              </span>
                            </div>
                            <div
                              title="Edit Faq"
                              className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
                              onClick={() => {
                                setModalShow(true);
                                setInitvalues(faq);
                              }}
                            >
                              <span className="svg-icon svg-icon-md svg-icon-warning">
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/icons/Communication/Write.svg"
                                  )}
                                />
                              </span>
                            </div>
                            <div
                              title="Delete Faq"
                              className="btn btn-icon btn-light btn-hover-danger btn-sm"
                              onClick={() => deleteFaq(faq.uid, fetchFaqs)}
                            >
                              <span className="svg-icon svg-icon-md svg-icon-danger">
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/icons/General/Trash.svg"
                                  )}
                                />
                              </span>
                            </div>
                          </span>
                        </div>{" "}
                      </Accordion.Toggle>
                      <Accordion.Collapse eventKey={String(faq.uid)}>
                        <Card.Body className="card-body pt-3 font-size-h6 font-weight-normal text-dark-50">
                          <div>{faq.answer}</div>
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                  );
                })
              ) : (
                  queryng ? <div className="d-flex align-items-center">
                    <div className="mr-2 text-muted">Loading...</div>
                    <div className="spinner spinner-primary mr-10"></div>
                  </div> : <div className="d-flex align-items-center">
                      <div className="mr-2 text-muted">No records found</div>
                    </div>
                )}
            </Accordion>
          </div>
        </div>
      </div>
    </>
  );
  function ContainerButtonFaqs(props) {
    const values = props.initvalues || {
      question: "",
      answer: "",
    };

    const [isSubmitting, setSubmitting] = useState(false)
    const handleChange = ({ target }) => {
      const { name, value } = target;
      values[name] = value;
    };
    const CreateFaq = () => {
      setSubmitting(true)

      Axios.post(FAQS_URL, values)
        .then(() => {
          props.addfaq(values);
          props.onHide();
          setSubmitting(false)
        })
        .catch(() => {
          props.onHide();
          setSubmitting(false)

        });
    };

    const updateFaq = () => {
      setSubmitting(true)

      // GET request using fetch inside useEffect React hook
      console.log(values);
      Axios.put(FAQS_URL + values.uid, values)
        .then((response) => response.data)
        .then(() => {
          props.fetchFaqs();
          props.onHide();
          setSubmitting(false)

        })
        .catch(() => {
          props.onHide();
          setSubmitting(false)

        });
    };
    return (
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">{values.uid ?"Edit Faq" :"New Faq"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="QuestionID">
              <Form.Label>Question</Form.Label>
              <Form.Control
                name="question"
                placeholder="Write a Question"
                onChange={handleChange}
                defaultValue={values.question}
              />
            </Form.Group>
            <Form.Group controlId="AnswerID">
              <Form.Label>Answer</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                name="answer"
                placeholder="Write an Answer"
                onChange={handleChange}
                defaultValue={values.answer}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <>
            <Button
              className="btn font-weight-bolder text-uppercase font-size-lg px-6"
              onClick={props.onHide}
              variant="secondary"
            >
              Close
            </Button>
            <Button
              disabled={isSubmitting}
              className="btn font-weight-bolder text-uppercase font-size-lg  px-6"
              onClick={values.uid ? updateFaq : CreateFaq}
              variant="primary"
            >
              {isSubmitting ?
                  <div className="d-flex align-items-center">
                    <div className="mr-2">Loading...</div>
                    <div className="spinner spinner-white mr-10"></div>
                  </div> : "Save"}
            </Button>
          </>
        </Modal.Footer>
      </Modal>
    );
  }
}
export default injectIntl(connect(null, auth.actions)(Profile));
